var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 10,
    viewBox: "0 0 15 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.95,
    d: "M14.0181 0.996933L13.5024 0.806641H13.3083C12.8956 0.806641 12.366 1.36358 8.46042 5.58595L7.27362 6.94374L6.73222 6.4002C6.27659 5.97565 5.84562 5.52217 5.44252 5.04295C4.72101 4.35039 3.97271 3.52221 3.30159 2.77551C2.01295 1.33625 1.54768 0.833977 1.04594 0.833977H0.865829L0.41449 0.956194L0.0917969 1.83851L0.438065 2.23196C1.21318 3.13733 2.0108 4.02019 2.83737 4.87999C3.97163 6.11556 5.10696 7.29645 6.21548 8.4232L6.65396 8.78985L7.25969 9.29266L7.78929 8.85793C7.98226 8.66764 8.23956 8.383 8.52473 8.05709C8.96214 7.54088 9.42743 7.05202 9.91737 6.59049C10.6132 5.77625 11.4644 4.93413 12.2127 4.18743C13.8765 2.50374 14.2753 2.10975 14.1467 1.47186L14.0181 0.996933Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.0364197,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/down-arrow.23f224578446e4179c49dc3ce06e919b.svg";
export { ForwardRef as ReactComponent };